import React from 'react';
import { trans } from '@spotahome/soyuz/client';

import ShieldIcon from '@components/icons/ShieldIcon';
import HandsIcon from '@components/icons/HandsIcon';
import SectionOverlay from '@components/SectionOverlay';

import TextBlock from '@components/TextBlock';
import FeatureBoxList from '@components/FeatureBoxList';

import './GuaranteeSection.scss';

const featureList = [
  {
    icon: <ShieldIcon />,
    title: 'home.tenant.guarantee-section.first-item.title',
    description: 'home.tenant.guarantee-section.first-item.content'
  },
  {
    icon: <HandsIcon />,
    title: 'home.tenant.guarantee-section.second-item.title',
    description: 'home.tenant.guarantee-section.second-item.content'
  }
];

const GuaranteeSection = () => (
  <section className="guarantee-section">
    <SectionOverlay>
      <TextBlock
        title={trans('home.tenant.guarantee-section.title')}
        content={trans('home.tenant.guarantee-section.subtitle')}
        titleSize="big"
        titleTag="h2"
      />
      <FeatureBoxList featureList={featureList} />
    </SectionOverlay>
  </section>
);

export default GuaranteeSection;
